import 'bootstrap/js/dist/collapse';
import './overlay';

$(document).ready(function () {
  Sceon.ClassifiedAd = {};
  Sceon.ClassifiedAd.PagingUrl = 'paging';

  if ($(document).find('.daily-escort-filter .search-input').length) {
    const searchInput = $(document).find('.daily-escort-filter .search-input');
    let timer = null;
    if (!searchInput.length) {
      return;
    }
    searchInput
      .blur(function () {
        if ($(this).val().trim().length < 1) {
          $(this).val('');
        }
        let val = decodeURI($(this).val());
        $('.form-control.search-input').val(val);
      })
      .keyup(function () {
        clearTimeout(timer);
        timer = setTimeout(
          () => Sceon.ClassifiedAd.setHash(Sceon.ClassifiedAd.makeHash()),
          500,
        );
      });
  }

  if ($('.daily-escort-filter .sort-select').length) {
    $('.sort-select:not(:disabled)').change(function () {
      let val = $(this).val();
      let name = $(this).attr('name');

      $(`.form-check-input[name="${name}"][value="${val}"]`).prop(
        'checked',
        true,
      );

      if (val == 'null') {
        $(document)
          .find(`.form-check-input[name="${name}"]`)
          .prop('checked', false);
      }

      setTimeout(() => {
        Sceon.ClassifiedAd.setSelectedCount();
      });

      if (event) {
        Sceon.ClassifiedAd.setHash(Sceon.ClassifiedAd.makeHash());
      }
    });
  }

  if ($('.pagination-perpage select').length) {
    $(document).on('change', '.pagination-perpage select', function () {
      let val = $(this).val();
      Sceon.ClassifiedAd.setHash(
        Sceon.ClassifiedAd.makeHash({ per_page: val }),
      );
    });
  }

  Sceon.ClassifiedAd.Load = function () {
    let ca_overlay = new Sceon.Overlay($('main'), {
      loader: '/img/loader-tiny.gif',
      offset: { bottom: 0, top: 0, left: '1px' },
    });
    ca_overlay.enable();

    let filter = Sceon.ClassifiedAd.parseHash();
    $('html, body').animate({ scrollTop: 0 }, 200);

    $.ajax({
      method: 'POST',
      url: location.href,
      data: {
        filter,
      },
      success: function (resp) {
        if (resp) {
          $('.daily-escort-list').replaceWith(resp);
          ca_overlay.disable();
        }

        let hash = location.hash.substring(1);

        if (hash.length > 0) {
          $('.reset-category-btn').removeAttr('hidden');
        } else {
          $('.reset-category-btn').attr('hidden', 'hidden');
        }

        Sceon.ClassifiedAd.onPrClick(location.hash);
      },
      error: function (err) {
        ca_overlay.disable();
      },
    });
  };

  Sceon.ClassifiedAd.setCheckboxesFromHash = function () {
    let hash = location.hash.substring(1);

    // Sceon.ClassifiedAd.Reset();

    if (hash.length > 0) {
      let objs = hash.split(';');

      objs.forEach((el) => {
        let name = el.split('=')[0];
        let val = el.split('=')[1];

        if (name && val) {
          $(`[name=${name}]`).each((index, elm) => {
            if (elm instanceof HTMLSelectElement) {
              $(elm).val(val);
              $(elm).trigger('change');
            } else if ($(elm).is("input[type='radio']")) {
              if ($(elm).val() === val) {
                $(elm).prop('checked', true);
              }
            } else {
              $(elm).val(decodeURI(val));
            }
          });
        }
      });

      $('.reset-category-btn').removeAttr('hidden');
    } else {
      $('.reset-category-btn').attr('hidden', 'hidden');
    }

    Sceon.ClassifiedAd.setSelectedCount();
  };

  Sceon.ClassifiedAd.getFilter = function (params = {}) {
    let filter = {};

    if (
      $(document).find('.daily-escort-filter .search-input').val().trim().length
    ) {
      filter.text = decodeURI(
        $('.daily-escort-filter .search-input').val().trim(),
      );
    }

    $(document)
      .find('.daily-escort-filter select:not(:disabled)')
      .each((ind, elm) => {
        const val = $(elm).val();
        if (val.length && val != 'null') {
          filter[$(elm).attr('name')] = val;
        }
      });

    if ($('.pagination-perpage select').length) {
      filter.per_page = $('.pagination-perpage select').val();
      filter.page = 1;
    }

    filter = {
      ...filter,
      ...params,
    };
    return filter;
  };

  Sceon.ClassifiedAd.parseHash = function () {
    let hash = location.hash.substring(1);
    let filter = {};
    if (!hash.length) {
      return {};
    }
    let params = hash.split(';');
    for (let i in params) {
      let name = params[i].split('=')[0];
      let val = params[i].split('=')[1];
      if (name && val) {
        filter[name] = val;
      }
    }
    return filter;
  };

  Sceon.ClassifiedAd.makeHash = function (params = {}) {
    let filter = Sceon.ClassifiedAd.getFilter(params);
    let hash = '';
    for (let i in filter) {
      hash += `${i}=${filter[i]};`;
    }
    return hash;
  };

  Sceon.ClassifiedAd.setHash = function (hash) {
    if (hash.length) {
      document.location.hash = '#' + hash;
    } else {
      document.location.hash = '';
    }
    return false;
  };

  Sceon.ClassifiedAd.paginate = function (page) {
    Sceon.ClassifiedAd.setHash(Sceon.ClassifiedAd.makeHash({ page }));
  };

  Sceon.ClassifiedAd.initDialogSubmit = function () {
    $('.submit-btn').on('click', function () {
      let parent = $('.daily-escort-filter');
      let form = $(this).parents('#sc-dialog-daily-filter').find('form');

      let selected = $(form).find('.form-check-input:checked');

      $(parent)
        .find('.search-input')
        .val(decodeURI($(form).find('.search-input').val()));

      selected.map(function (ind, el) {
        let val = $(el).val();
        let name = $(el).attr('name');
        $(parent).find(`select[name=${name}]`).val(val);
        $(parent).find(`select[name=${name}]`).trigger('change');
      });

      // Sceon.ClassifiedAd.setHash(Sceon.ClassifiedAd.makeHash());
    });
  };

  Sceon.ClassifiedAd.initDialogReset = function () {
    $('.reset-category-btn').on('click', function () {
      let parent = $('.daily-escort-filter');
      const form = $('#sc-dialog-daily-filter').find('form');
      $(form).find('input[type="text"]').val('');
      $(parent).find('input[type="text"]').val('');

      Sceon.ClassifiedAd.Reset();
      Sceon.ClassifiedAd.setHash(Sceon.ClassifiedAd.makeHash());
    });
  };

  Sceon.ClassifiedAd.Reset = function () {
    let parent = $('.daily-escort-filter');
    const form = $('#sc-dialog-daily-filter').find('form');
    $(form).find('input[type="radio"]:not(:disabled)').prop('checked', false);
    $('.reset-category-btn').attr('hidden', 'hidden');

    $(parent).find('select:not(:disabled)').val('null');
  };

  Sceon.ClassifiedAd.setSelectedCount = function () {
    $('.selected-count').text('');

    if ($('#sc-dialog-daily-filter .form-check-input:checked').length) {
      $('#sc-dialog-daily-filter .form-check-input:checked').each(function (
        ind,
        el,
      ) {
        let name = $(el).attr('name');
        let checked_count = $(
          '.form-check-input[name="' + name + '"]:checked',
        ).length;
        let $target = $(el).closest('.accordion-item').find('.selected-count');

        if (checked_count) {
          $target.text(`(${checked_count})`);
        } else {
          $target.text('');
        }
      });
    }
  };

  Sceon.HashController = {
    _current: '',

    init: function () {
      window.onhashchange = function () {
        Sceon.HashController.check();
      };
      Sceon.HashController.check();
    },

    check: function () {
      let hash = document.location.hash.substring(1);

      if (hash !== this._current) {
        this._current = hash;

        // Sceon.ClassifiedAd.setCheckboxesFromHash();
        Sceon.ClassifiedAd.Load();
      }
    },
  };

  Sceon.ClassifiedAd.init = function () {
    Sceon.ClassifiedAd.initDialogSubmit();
    Sceon.ClassifiedAd.initDialogReset();
    Sceon.ClassifiedAd.setSelectedCount();
  };

  Sceon.ClassifiedAd.setCheckboxesFromHash();
  Sceon.HashController.init();
  Sceon.ClassifiedAd.init();

  Sceon.ClassifiedAd.onPrClick = function (hash) {
    $(document)
      .unbind('click auxclick')
      .on(
        'click auxclick',
        '.daily-escort-item .escort-avatar a, .daily-escort-item .escort-header a',
        function () {
          event.preventDefault();
          let category = location.pathname.substring(16).toUpperCase();
          if (category.length) {
            hash += hash.length
              ? `;category=${category}`
              : `#category=${category}`;
          }
          let href = $(this).attr('href');
          if (event.type === 'click') {
            location.href = `${href}${hash}`;
          } else if (event.type === 'auxclick' && event.which !== 3) {
            window.open(`${href}${hash}`);
          }
        },
      );
  };
  Sceon.ClassifiedAd.onPrClick(location.hash);
});
